import { ClockIcon, DrivingIcon, InterJourneyIcon, MoonIcon } from "../../assets/imgs";
import CalendarEditIcon from "../../assets/imgs/CalendarEdit";
import CalendarSearchIcon from "../../assets/imgs/CalendarSearch";
import { InfractionTypes } from "../../store/types/infraction";
import { formatSecondsToFullHour } from "../../utils/functions/formatters";

const InfractionItem: React.FC<{ type: string, value: number }> = ({
  type,
  value
}) => {
  if (type === InfractionTypes.EXTRA_HOUR) {
    return (
      <div className="flex">
        <div className="inline-flex items-center justify-center w-8 h-8 mr-1 bg-red rounded-full mt-[3px]">
          <ClockIcon width={19} height={19} color={'#fff'}/>
        </div>
        <span className="items-center justify-center text-sm mt-2 ml-1 text-gray_2">{formatSecondsToFullHour(value)}</span>
      </div>
    );
  
  } else if (type === InfractionTypes.INTERJOURNEY_TIME) {
    return (
      <div className="flex">
        <div className="inline-flex items-center justify-center w-8 h-8 mr-1 bg-red rounded-full mt-[3px] pt-1 pl-2">
          <MoonIcon width={30} height={30} color={'#fff'}/>
        </div>
        <span className="items-center justify-center text-sm mt-2 ml-1 text-gray_2">{value === 0 ?  'Não houve descanso' :formatSecondsToFullHour(value)}</span>
      </div>
    );
  } else if (type === InfractionTypes.LONG_WORKING_TIME) {
    return (
      <div className="flex">
        <div className="inline-flex items-center justify-center w-8 h-8 mr-1 bg-red rounded-full mt-[3px]">
          <DrivingIcon width={20} height={20} color={'#fff'}/>
        </div>
        <span className="items-center justify-center text-sm mt-2 ml-1 text-gray_2">{formatSecondsToFullHour(value)}</span>
      </div>
    );
  } else if (type === InfractionTypes.MEAL_TIME) {
    return (
      <div className="flex">
        <div className="inline-flex items-center justify-center w-8 h-8 mr-1 bg-red rounded-full mt-[3px] pb-[1px] pl-[2px]">
          <InterJourneyIcon width={20} height={20} color={'#fff'}/>
        </div>
        <span className="items-center justify-center text-sm mt-2 ml-1 text-gray_2">{value === 0 ?  'Não houve refeição' :formatSecondsToFullHour(value)}</span>
      </div>
    );
  } else if (type === InfractionTypes.ALTERED_MACRO) {
    return (
      <div className="flex">
        <div className="inline-flex items-center justify-center w-8 h-8 mr-1 bg-red rounded-full mt-[3px] pt-[5px] pl-[6px]">
          <CalendarEditIcon width={28} height={28} color={'#fff'}/>
        </div>
        <span className="items-center justify-center text-sm mt-2 ml-1 text-gray_2">{value}</span>
      </div>
    );
  } else {
    return (
      <div className="flex">
        <div className="inline-flex items-center justify-center w-8 h-8 mr-1 bg-red rounded-full mt-[3px] pt-[5px] pl-[6px]">
          <CalendarSearchIcon width={30} height={30} color={'#fff'}/>
        </div>
        <span className="items-center justify-center text-sm mt-2 ml-1 text-gray_2">{value}</span>
      </div>
    );
  }
};

export default InfractionItem;
